<div class="card card-redlaboral m-4">
    <div class="card-body">
        <div class="row">
            <div class="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <h4 class="mt-0 mb-0 text-primary">
                    <i class="fa-solid fa-table"></i>
                    Catalogos
                </h4>
            </div>
            <div class="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            </div>
        </div>
        <div class="row">
            <div class="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div class="form-group mb-3">
                    <label>Catalogo a editar</label>
                    <div>
                        <select class="form-control">
                            <option value=""></option>
                            <option value="1">Catalogo A</option>
                            <option value="2">Catalogo B</option>
                            <option value="3">Catalogo C</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div class="mt-button">
                    <button type="button" class="btn btn-primary me-2">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        Buscar
                    </button>
                    <button type="button" class="btn btn-success">
                        <i class="fa-solid fa-plus"></i>
                        Agregar
                    </button>
                </div>
            </div>
        </div>
        <hr class="mt-3 mb-3" />
        <div class="table-responsive">
            <table class="table table-theme">
                <thead>
                    <tr>
                        <th class="text-start">Catálogo</th>
                        <th class="text-start">Descripción</th>
                        <th class="text-center" width="110px">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    @for(item of [1,2,3,4,5,6,7,8,9,10]; track item)
                    {
                        <tr>
                            <td class="text-start">Catalogo A</td>
                            <td class="text-start">Descripción</td>
                            <td class="text-center">
                                <button
                                    type="button"
                                    class="btn btn-primary btn-sm me-2"
                                    title="Editar">
                                    <i class="fa-solid fa-pencil"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-outline-danger btn-sm me-2"
                                    title="Eliminar">
                                    <i class="fa-solid fa-trash-can"></i>
                                </button>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>